export default __webpack_public_path__ + "static/media/backend.b948453a.png";